(function () {
  'use strict';

  function getCardWrapper(node) {
    return node.closest('[data-bys-card-target]') || node.closest('.card-wrapper') || node.closest('.product-card-wrapper') || node.closest('.card');
  }

  function findPdpVariantInput(swatch) {
    // On PDP: try to find the matching variant input/button outside the swatches container
    var variantId = swatch.getAttribute('data-variant-id');
    if (!variantId || variantId === '0') return null;
    var label = swatch.getAttribute('aria-label');
    if (!label) return null;
    // Search for radio inputs or labels with matching value within product-info
    var productInfo = swatch.closest('product-info, main-product, .product, .main-product, [data-product-info]');
    if (!productInfo) productInfo = document.querySelector('product-info, main-product, .product, .main-product');
    if (!productInfo) return null;
    // Look for inputs with value=label in variant-picker area
    var inputs = productInfo.querySelectorAll('input[type=radio]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === label) return inputs[i];
    }
    // Look for buttons whose text matches
    var buttons = productInfo.querySelectorAll('label, button');
    for (var j = 0; j < buttons.length; j++) {
      var b = buttons[j];
      if (b.classList.contains('bys-swatch')) continue;
      var txt = (b.textContent || '').trim();
      if (txt === label) return b;
    }
    return null;
  }

  function activateSwatch(swatch) {
    var container = swatch.closest('.bys-swatches');
    if (!container) return;
    var siblings = container.querySelectorAll('.bys-swatch');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('is-selected');
      siblings[i].setAttribute('aria-pressed', 'false');
    }
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');

    // PDP mode: forward click to the existing variant input/button
    if (container.classList.contains('bys-swatches--pdp')) {
      var pdpInput = findPdpVariantInput(swatch);
      if (pdpInput) {
        if (pdpInput.tagName === 'INPUT') {
          pdpInput.checked = true;
          pdpInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          pdpInput.click();
        }
        return;
      }
    }

    // Card mode: swap image and update product links
    var newImg = swatch.getAttribute('data-variant-image');
    var newImg2x = swatch.getAttribute('data-variant-image-2x');
    var variantUrl = swatch.getAttribute('data-variant-url');
    var card = getCardWrapper(container) || container.parentElement;
    if (!card) return;

    if (newImg) {
      var imgs = card.querySelectorAll('.card__media img, .media img, [data-bys-card-image] img');
      for (var j = 0; j < imgs.length; j++) {
        var im = imgs[j];
        if (im.dataset.bysOriginalSrc === undefined) {
          im.dataset.bysOriginalSrc = im.getAttribute('src') || '';
          im.dataset.bysOriginalSrcset = im.getAttribute('srcset') || '';
        }
        im.setAttribute('src', newImg);
        if (newImg2x) {
          im.setAttribute('srcset', newImg + ' 1x, ' + newImg2x + ' 2x');
        } else {
          im.removeAttribute('srcset');
        }
      }
    }

    updateHoverImage(card, swatch); if (variantUrl) {
      var anchors = card.querySelectorAll('a[href]');
      for (var k = 0; k < anchors.length; k++) {
        var a = anchors[k];
        if (a.classList.contains('bys-swatch')) continue;
        var href = a.getAttribute('href') || '';
        if (href && href.indexOf('/products/') !== -1) {
          var base = href.split('?')[0];
          var qIdx = variantUrl.indexOf('?');
          var vQuery = qIdx !== -1 ? variantUrl.substring(qIdx) : '';
          a.setAttribute('href', base + vQuery);
        }
      }
    }
  }

  function killEvent(e) {
    var swatch = e.target.closest && e.target.closest('.bys-swatch');
    if (!swatch) return false;
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.preventDefault();
    return swatch;
  }

  function onClickCapture(e) {
    var swatch = killEvent(e);
    if (swatch) activateSwatch(swatch);
  }

function onPointerCapture(e) {
      killEvent(e);
    }

    function onTouchEndCapture(e) {
      var swatch = killEvent(e);
      if (swatch) activateSwatch(swatch);
    }

    function attachGlobalListeners() {
      if (window.__bysSwatchListenersAttached) return;
      window.__bysSwatchListenersAttached = true;
      // Click/auxclick: ativam o swatch (desktop principalmente)
      document.addEventListener('click', onClickCapture, { capture: true });
      document.addEventListener('auxclick', onClickCapture, { capture: true });
      // Mouse/pointer: apenas matam o evento para nao disparar comportamento padrao
      document.addEventListener('mousedown', onPointerCapture, { capture: true });
      document.addEventListener('mouseup', onPointerCapture, { capture: true });
      document.addEventListener('pointerdown', onPointerCapture, { capture: true });
      document.addEventListener('pointerup', onPointerCapture, { capture: true });
      // Touch: passive:false para poder preventDefault. No touchend, ativa o swatch (fallback caso click sintetico nao dispare em iOS).
      document.addEventListener('touchstart', onPointerCapture, { capture: true, passive: false });
      document.addEventListener('touchend', onTouchEndCapture, { capture: true, passive: false });
    }
var productCache = {}; function updateHoverImage(card, swatch) { var hoverContainer = card.querySelector('.media--hover-effect'); if (!hoverContainer) return; var imgs = hoverContainer.querySelectorAll('img'); if (imgs.length < 2) return; var hoverImg = imgs[1]; var variantId = swatch.getAttribute('data-variant-id'); var variantUrl = swatch.getAttribute('data-variant-url'); if (!variantId || !variantUrl) return; var handle = variantUrl.split('/products/')[1]; if (!handle) return; handle = handle.split('?')[0].split('/')[0]; var productUrl = '/products/' + handle + '.js'; function applyHover(product) { if (!product || !product.variants || !product.images) return; var variant = null; for (var i = 0; i < product.variants.length; i++) { if (String(product.variants[i].id) === String(variantId)) { variant = product.variants[i]; break; } } if (!variant || !variant.featured_image) return; var pos = variant.featured_image.position; var featuredPositions = {}; for (var fi = 0; fi < product.variants.length; fi++) { if (product.variants[fi].featured_image) featuredPositions[product.variants[fi].featured_image.position] = true; } var nextImgUrl = null; for (var dp = 1; dp < product.images.length; dp++) { var checkPos = pos + dp; if (checkPos <= product.images.length && !featuredPositions[checkPos]) { nextImgUrl = product.images[checkPos - 1]; break; } var checkPos2 = pos - dp; if (checkPos2 >= 1 && !featuredPositions[checkPos2]) { nextImgUrl = product.images[checkPos2 - 1]; break; } } if (!nextImgUrl) return; if (hoverImg.dataset.bysOriginalSrc === undefined) { hoverImg.dataset.bysOriginalSrc = hoverImg.getAttribute('src') || ''; hoverImg.dataset.bysOriginalSrcset = hoverImg.getAttribute('srcset') || ''; } var sized = nextImgUrl.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_800x$1$2'); hoverImg.setAttribute('src', sized); hoverImg.removeAttribute('srcset'); } if (productCache[handle]) { applyHover(productCache[handle]); } else { fetch(productUrl).then(function(r){ return r.json(); }).then(function(p){ productCache[handle] = p; applyHover(p); }).catch(function(){}); } }  

  function init() {
    attachGlobalListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();